import { apiServiceConstants } from "../../constants/apiService.constants";
import { ApiResponse } from "../../models/apiResponse.model";
import { apiService } from "../../services/apiService";
import { utilService } from "../../services/utilService";
import { Subject } from "rxjs";
import {
  CareTeamFullListResInterface,
  CareTeamFullListResModel,
  CareTeamRequestParams,
  CommonProviderFullListResInterface,
  CommonProviderFullListResModel,
  NewSupportStaffInputParams,
  PatientSearchWithOutMRNParms,
  PatientSearchWithMRNParms,
  UpdateCareTeamRequestParams,
  UpdateCareTeamResponseInterface,
  UpdateCareTeamResponseModel,
} from "./StatusBoard.model";
import {
  ColumnListResModel,
  ColumnListResultInterface,
  CustomColumnListResModel,
  CustomColumnListResultInterface,
  SendPrimaryMdSmsReq,
  SendPrimaryMdSmsRes,
  StatusBoardColumRequestParams,
  StatusBoardColumUpdateRequestParams,
  StatusBoardRequestParams,
  StatusBoardResModel,
  StatusBoardResultInterface,
} from "./StatusBoard.model";

let rowData: any;
let statusBoardId: any;
let statusBoardData: any;
let sbTableUpdated = new Subject<any>();
let selectedStatusBoardData: any;
let selectedRowId: any;
let tableData: Array<any> = [];
let selectedProviderPoupType = "";
let selectedCareTeam: any = undefined;
let clearCareTeamSelected = new Subject<any>();
let getNotifiedBedDetails = new Subject<any>();
let removeIndication = new Subject<any>();
let notifyStatusTable = new Subject<any>();
let checkedReminders: any = [];
let sbCareTeamStaffUpdated = new Subject<any>();
let currentSupportStaffList: any = [];
let bedTransferOrSwap = new Subject<any>();
let isBedSwappedOrTransferredId = "";
let isBedSwappedOrTransferredFromId = "";

/*
 * A 113 KB literal of fake units, staff and patients lived here, reachable
 * only through the `demo` flag below, which has been false. It was still
 * parsed and shipped to every browser -- 80% of this file -- and carried
 * invented clinician names and photo URLs on thecallcentral.com. Removed; the
 * demo path now says so rather than pretending to have data.
 */

const getUnitDetails = (params: StatusBoardRequestParams) => {
  return getListFromServer(params);
};

const getListFromServer = async (
  params: StatusBoardRequestParams
): Promise<StatusBoardResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/statusboard-v2/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const StatusBoardResp = res as StatusBoardResModel;
      const result: StatusBoardResultInterface = {
        isSuccess: StatusBoardResp.isSuccess,
        status: StatusBoardResp.status,
        message: StatusBoardResp.message,
        unitList: StatusBoardResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: StatusBoardResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};
const getAllColumnList = async (
  params: StatusBoardColumRequestParams
): Promise<ColumnListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/status-board-column/list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const columnList = res as ColumnListResModel;
      const result: ColumnListResultInterface = {
        isSuccess: columnList.isSuccess,
        status: columnList.status,
        message: columnList.message,
        columnList: columnList.result,
      };
      return result;
    })
    .catch((err) => {
      const result: ColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getAllCustomColumnList = async (
  params: StatusBoardColumRequestParams
): Promise<CustomColumnListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/create-column/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const columnList = res as CustomColumnListResModel;
      const result: CustomColumnListResultInterface = {
        isSuccess: columnList.isSuccess,
        status: columnList.status,
        message: columnList.message,
        columnList: columnList.result,
      };
      return result;
    })
    .catch((err) => {
      const result: CustomColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        columnList: [],
      };
      return result;
    });

  return respApiResult;
};

const updateColumnsList = async (
  params: StatusBoardColumUpdateRequestParams
): Promise<ColumnListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/status-board-column/list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unassignedShiftResp = res as ApiResponse;
      const result: ColumnListResultInterface = {
        isSuccess: unassignedShiftResp.isSuccess,
        status: unassignedShiftResp.status,
        message: unassignedShiftResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: ColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const updateCustomColumnList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/create-column/${
        params.id
      }/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unassignedShiftResp = res as ApiResponse;
      const result: ColumnListResultInterface = {
        isSuccess: unassignedShiftResp.isSuccess,
        status: unassignedShiftResp.status,
        message: unassignedShiftResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: ColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const addCustomColumnList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/create-column/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unassignedShiftResp = res as ApiResponse;
      const result: ColumnListResultInterface = {
        isSuccess: unassignedShiftResp.isSuccess,
        status: unassignedShiftResp.status,
        message: unassignedShiftResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: ColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getAllUnitList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/list-all/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unitList = res as any;
      const result: any = {
        isSuccess: unitList.isSuccess,
        status: unitList.status,
        message: unitList.message,
        unitList: unitList.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        unitList: [],
      };
      return result;
    });

  return respApiResult;
};

const searchUnit = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/list-all/?reg_code=${utilService.getNetwork()}&name=${
        params.name
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unitList = res as any;
      const result: any = {
        isSuccess: unitList.isSuccess,
        status: unitList.status,
        message: unitList.message,
        unitList: unitList.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        unitList: [],
      };
      return result;
    });

  return respApiResult;
};

const getAllBedList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/bed/swap-transfer/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const bedList = res as any;
      const result: any = {
        isSuccess: bedList.isSuccess,
        status: bedList.status,
        message: bedList.message,
        bedList: bedList.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        bedList: [],
      };
      return result;
    });

  return respApiResult;
};

const updatePatientBedNo = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/bed/swap-transfer/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unassignedShiftResp = res as ApiResponse;
      const result: any = {
        isSuccess: unassignedShiftResp.isSuccess,
        status: unassignedShiftResp.status,
        message: unassignedShiftResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: ColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const searchBed = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/bed/swap-transfer/?reg_code=${utilService.getNetwork()}&name=${
        params.name
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const bedList = res as any;
      const result: any = {
        isSuccess: bedList.isSuccess,
        status: bedList.status,
        message: bedList.message,
        bedList: bedList.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        bedList: [],
      };
      return result;
    });

  return respApiResult;
};

const getPatientData = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/patient-add/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const patientData = res as any;
      const result: any = {
        isSuccess: patientData.isSuccess,
        status: patientData.status,
        message: patientData.message,
        patientData: patientData.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        patientData: [],
      };
      return result;
    });

  return respApiResult;
};

const addPatientData = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/patient-add/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unassignedShiftResp = res as any;
      const result: any = {
        isSuccess: unassignedShiftResp.isSuccess,
        status: unassignedShiftResp.status,
        message: unassignedShiftResp.message,
        result:unassignedShiftResp.result?.[0]
      };
      return result;
    })
    .catch((err) => {
      const result: ColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        
      };
      return result;
    });

  return respApiResult;
};

const checkIfEmergencyCompleted = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/is-discharge-possible/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unassignedShiftResp = res as any;
      const result: any = {
        isSuccess: unassignedShiftResp.isSuccess,
        status: unassignedShiftResp.status,
        message: unassignedShiftResp.message,
        result: unassignedShiftResp.result?.[0],
      };
      return result;
    })
    .catch((err) => {
      const result: ColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const dischargePatient = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/discharge-patient/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const unassignedShiftResp = res as any;
      const result: any = {
        isSuccess: unassignedShiftResp.isSuccess,
        status: unassignedShiftResp.status,
        message: unassignedShiftResp.message,
        result: unassignedShiftResp.result?.[0],
      };
      return result;
    })
    .catch((err) => {
      const result: ColumnListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};
const updateTableData = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/status-board-column/list/${
        params.id
      }/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ApiResponse;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const updateDNR = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/update-dnr/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ApiResponse;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const updateTable = (type: any) => {
  sbTableUpdated.next(type);
};

const notifyBed = (bedDetails: any) => {
  getNotifiedBedDetails.next(bedDetails);
};

const primaryMdMessage = async (
  params: SendPrimaryMdSmsReq
): Promise<SendPrimaryMdSmsRes> => {
  const respApiResult = await apiService
    .apiCall(
      `user/connect/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const submitPrimaryMdMessageResp = res as SendPrimaryMdSmsRes;
      const result: SendPrimaryMdSmsRes = {
        isSuccess: submitPrimaryMdMessageResp.isSuccess,
        status: submitPrimaryMdMessageResp.status,
        message: submitPrimaryMdMessageResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: SendPrimaryMdSmsRes = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const handleErrorResponse = () => {};

const getAllCareTeam = async (
  params: CareTeamRequestParams
): Promise<CareTeamFullListResInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/careteam/list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const careTeamResp = res as CareTeamFullListResModel;
      const result: CareTeamFullListResInterface = {
        isSuccess: careTeamResp.isSuccess,
        status: careTeamResp.status,
        message: careTeamResp.message,
        groupList: careTeamResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: CareTeamFullListResInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const updateCareTeam = async (
  params: UpdateCareTeamRequestParams
): Promise<UpdateCareTeamResponseInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/careteam/list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as UpdateCareTeamResponseModel;
      const result: UpdateCareTeamResponseInterface = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
        groupList: response.result,
      };
      return result;
    })
    .catch((err) => {
      const result: UpdateCareTeamResponseInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const inPatientEmergency = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/patient-add-to-emergency/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const inPatientResp = res as any;
      const result: any = {
        isSuccess: inPatientResp.isSuccess,
        displayNotesCard: inPatientResp,
        status: inPatientResp.status,
        message: inPatientResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const statusBoardPatients = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/add-to-emergency-patients/?reg_code=${utilService.getNetwork()}&StatusBoardId=${
        params.StatusBoardId
      }&hour=${params.hour}$minute=${params.minute}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const patientResp = res as any;
      const result: any = {
        isSuccess: patientResp.isSuccess,
        displayNotesCard: patientResp,
        status: patientResp.status,
        message: patientResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const searchCareTeam = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/careteam/list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        isSuccess: resp.isSuccess,
        status: resp.status,
        message: resp.message,
        groupList: resp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        groupList: [],
      };
      return result;
    });

  return respApiResult;
};

const getAllCommonProvider = async (
  params: CareTeamRequestParams
): Promise<CommonProviderFullListResInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/commonprovider/list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const careTeamResp = res as CommonProviderFullListResModel;
      const result: CommonProviderFullListResInterface = {
        isSuccess: careTeamResp.isSuccess,
        status: careTeamResp.status,
        message: careTeamResp.message,
        groupList: careTeamResp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: CommonProviderFullListResInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const searchCommonProvider = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/commonprovider/list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        isSuccess: resp.isSuccess,
        status: resp.status,
        message: resp.message,
        groupList: resp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        groupList: [],
      };
      return result;
    });

  return respApiResult;
};
const updateCommonProvider = async (
  params: any
): Promise<CommonProviderFullListResInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/commonprovider/list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as CommonProviderFullListResModel;
      const result: CommonProviderFullListResInterface = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
        groupList: response.result,
      };
      return result;
    })
    .catch((err) => {
      const result: CommonProviderFullListResInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const deleteSupportStaff = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/common-provider-add/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        message: resp.message,
        status: resp.status,
        isSuccess: resp.isSuccess,
        result: resp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const updateColumnSize = async (params: any): Promise<ApiResponse> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/custom-statusboard-column/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ApiResponse;
      const result: ApiResponse = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((err) => {
      const result: ApiResponse = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const notifyCareTeam = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `notification/careteam/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        message: resp.message,
        status: resp.status,
        isSuccess: resp.isSuccess,
        result: resp.result,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const deSelectCareTeam = (status: any) => {
  clearCareTeamSelected.next(status);
};
// remove care team indication from bed
const removeIndicationForBed = (status: any) => {
  removeIndication.next(status);
};
// notify status table to send care team notification
const sendCareTeamNotification = (status: any) => {
  notifyStatusTable.next(status);
};

const updateCareTeamSupportStaff = (data: any) => {
  sbCareTeamStaffUpdated.next(data);
};
const addNewSupportStaff = async (
  params: NewSupportStaffInputParams
): Promise<ApiResponse> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/common-provider-add/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ApiResponse;
      const result: ApiResponse = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((err) => {
      const result: ApiResponse = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const patientSearchWithOutMRN = async (
  params: PatientSearchWithOutMRNParms
): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `epic/search/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response:any = res;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
        patientData: response.result
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};
const patientSearchWithMRN = async (
  params: PatientSearchWithMRNParms
): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `hospital/patient-search/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response:any = res;
      const result: any = {
        isSuccess: response.isSuccess,
        status: response.status,
        message: response.message,
        patientData: response.result
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};






// For updating the reminder list
const bedTransferSwap = () => {
  bedTransferOrSwap.next();
};

export const statusBoardService = {
  getUnitDetails,
  getAllColumnList,
  updateColumnsList,
  updateColumnSize,
  getAllCustomColumnList,
  rowData,
  statusBoardId,
  updateCustomColumnList,
  addCustomColumnList,
  statusBoardData,
  getAllUnitList,
  searchUnit,
  getAllBedList,
  updatePatientBedNo,
  searchBed,
  getPatientData,
  addPatientData,
  dischargePatient,
  updateTableData,
  updateDNR,
  updateTable,
  sbTableUpdated,
  selectedStatusBoardData,
  primaryMdMessage,
  handleErrorResponse,
  selectedRowId,
  tableData,
  getAllCareTeam,
  updateCareTeam,
  searchCareTeam,
  getAllCommonProvider,
  searchCommonProvider,
  updateCommonProvider,
  selectedProviderPoupType,
  deleteSupportStaff,
  selectedCareTeam,
  notifyCareTeam,
  clearCareTeamSelected,
  deSelectCareTeam,
  notifyBed,
  getNotifiedBedDetails,
  removeIndicationForBed,
  removeIndication,
  sendCareTeamNotification,
  notifyStatusTable,
  checkedReminders,
  updateCareTeamSupportStaff,
  sbCareTeamStaffUpdated,
  currentSupportStaffList,
  addNewSupportStaff,
  bedTransferSwap,
  bedTransferOrSwap,
  isBedSwappedOrTransferredId,
  isBedSwappedOrTransferredFromId,
  inPatientEmergency,
  statusBoardPatients,
  checkIfEmergencyCompleted,
  patientSearchWithOutMRN,
  patientSearchWithMRN
};
